import type { Roles } from './types';

export const roles: Roles = {
  modules: ["modCase", "modEvidence", "modDrug", "modAnalysis", "modForensic", "modStats", "modSystem"],
  perms: ["permView", "permCreate", "permEdit", "permDelete", "permApprove", "permExport"],
  list: [
    {
      id: "admin", ko: "시스템 관리자", mn: "Системийн админ", members: 2, color: "#A50F1D",
      matrix: {
        modCase: [1, 1, 1, 1, 1, 1], modEvidence: [1, 1, 1, 1, 1, 1], modDrug: [1, 1, 1, 1, 1, 1],
        modAnalysis: [1, 1, 1, 1, 1, 1], modForensic: [1, 1, 1, 1, 1, 1], modStats: [1, 1, 1, 1, 1, 1], modSystem: [1, 1, 1, 1, 1, 1],
      },
    },
    {
      id: "lead", ko: "수사 팀장", mn: "Мөрдөн шалгах багийн ахлагч", members: 5, color: "#0054A6",
      matrix: {
        modCase: [1, 1, 1, 1, 1, 1], modEvidence: [1, 1, 1, 0, 1, 1], modDrug: [1, 1, 1, 0, 0, 1],
        modAnalysis: [1, 1, 1, 0, 0, 1], modForensic: [1, 1, 0, 0, 1, 1], modStats: [1, 1, 1, 0, 0, 1], modSystem: [1, 0, 0, 0, 0, 0],
      },
    },
    {
      id: "investigator", ko: "수사관", mn: "Мөрдөгч", members: 23, color: "#1B6FBE",
      matrix: {
        modCase: [1, 1, 1, 0, 0, 1], modEvidence: [1, 1, 1, 0, 0, 1], modDrug: [1, 0, 0, 0, 0, 1],
        modAnalysis: [1, 1, 1, 0, 0, 1], modForensic: [1, 1, 0, 0, 0, 1], modStats: [1, 0, 0, 0, 0, 1], modSystem: [0, 0, 0, 0, 0, 0],
      },
    },
    {
      id: "forensic", ko: "감정관", mn: "Шинжээч", members: 7, color: "#C77B0A",
      matrix: {
        modCase: [1, 0, 0, 0, 0, 0], modEvidence: [1, 1, 1, 0, 0, 1], modDrug: [1, 1, 1, 0, 1, 1],
        modAnalysis: [1, 1, 1, 0, 0, 1], modForensic: [1, 1, 1, 1, 1, 1], modStats: [1, 0, 0, 0, 0, 1], modSystem: [0, 0, 0, 0, 0, 0],
      },
    },
    {
      id: "viewer", ko: "조회 전용", mn: "Зөвхөн үзэх", members: 14, color: "#707070",
      matrix: {
        modCase: [1, 0, 0, 0, 0, 0], modEvidence: [1, 0, 0, 0, 0, 0], modDrug: [1, 0, 0, 0, 0, 0],
        modAnalysis: [1, 0, 0, 0, 0, 0], modForensic: [1, 0, 0, 0, 0, 0], modStats: [1, 0, 0, 0, 0, 1], modSystem: [0, 0, 0, 0, 0, 0],
      },
    },
  ],
};
